<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-layout justify-center align-center row>
			<v-flex xs1/>
			<v-flex xs2>
				<v-text-field
					browser-autocomplete="off"
					class="ma-2"
					v-model="dataTable.searchFields.projectCode"
					label="Numer projektu"
					aria-label="project code"
					for="volunteer-reports-list-project-code"
					id="volunteer-reports-list-project-code"
				></v-text-field>
			</v-flex>
			<v-flex xs3>
				<v-text-field
					browser-autocomplete="off"
					class="ma-2"
					v-model="dataTable.searchFields.projectTitle"
					label="Nazwa projektu"
					aria-label="project title"
					clearable
				></v-text-field>
			</v-flex>
			<v-flex xs2>
				<v-select
					class="ma-2"
					v-model="dataTable.searchFields.status"
					:items="statusList"
					label="Status"
					aria-label="status"
					clearable
				></v-select>
			</v-flex>
			<v-flex xs3>
				<v-layout align-center justify-center>
					<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
				</v-layout>
			</v-flex>
			<v-flex xs1/>
		</v-layout>

		<v-data-table
			:headers="dataTable.headers"
			:rows-per-page-items="[10,20,25]"
			:items="dataTable.itemList"
			:pagination.sync="dataTable.pagination"
			:total-items="dataTable.itemCount"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<td>{{props.item.projectCode}}</td>
				<td>{{props.item.projectTitle}}</td>
				<td>{{props.item.reportDate}}</td>
				<td>{{props.item.status}}
					<span class="ml-1" v-if="props.item.status === 'Do poprawek'">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-icon size="18" color="blue" dark v-on="on">mail_outline</v-icon>
							</template>
							<span>{{props.item.detailedCorrectionCause}}</span>
						</v-tooltip>
					</span>
				</td>
				<td>
					<v-icon
						v-if="props.item.status === 'Nierozpoczęty'"
						@click="startReport(props.item)"
						title="Rozpocznij"
					>add_box
					</v-icon>
					<v-icon
						v-if="props.item.status === 'Rozpoczęty' || props.item.status === 'Do poprawek'"
						@click="showReportForm(props.item)"
						title="Edytuj"
					>edit
					</v-icon>
					<v-icon
						v-if="props.item.status === 'Zakończony'"
						@click="showReportForm(props.item)"
						title="Szczegóły"
					>description
					</v-icon>
				</td>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import {VolunteerReport} from "@/api/generated/VolunteerReport";
	import {Pagination} from "@/utils/PaginationUtils";
	import {Api} from "@/api";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "VolunteerReportTable",

    mixins: [Filters],

		data () {
			return {
				dataTable: {
					search: "",
					headers: [
						{text: "Numer projektu", value: "projectCode", sortable: true},
						{text: "Nazwa projektu", value: "projectTitle", sortable: true},
						{text: "Termin wykonania raportu", value: "reportDate", sortable: true},
						{text: "Status", value: "status", sortable: true},
						{text: "Akcje", value: "action", sortable: false}
					],
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
						sortBy: null
					},
					searchFields: Pagination.initSearchedFields([
						'projectCode',
						'projectTitle',
						'status'
					])
				},
				statusList: [
					"Nierozpoczęty",
					"Rozpoczęty",
					"Do poprawek",
					"Zakończony"
				]
			};
		},

    mounted() {
      this.dataTable.searchFields = this.retrieveFilters(this.dataTable.searchFields);
      this.dataTable.pagination = this.retrievePagination(this.dataTable.pagination);
      this.buildNewSearch();
    },

		watch: {
			"dataTable.pagination": {
				handler (pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true,
			}
		},

		computed: {
			pages () {
				// paginacja nie została zainicjalizowana
				if (this.dataTable.pagination.rowsPerPage === undefined) {
					return 0;
				}
				return Math.ceil(this.dataTable.itemCount / this.dataTable.pagination.rowsPerPage);
			},
		},

		methods: {
			buildNewSearch () {
				this.dataTable.search = this.buildSearchCriteria();
				this.getItemList();
			},

			buildSearchCriteria () {
				return Pagination.buildSearchCriteria(this.dataTable.searchFields, false);
			},

			buildSort () {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			resetSearch () {
				this.dataTable.searchFields.projectTitle = '';
				this.dataTable.searchFields.status = '';
				this.dataTable.search = '';
				this.getItemList();
			},

			getItemList () {
				let sort = this.buildSort();
				Api.get(this,
					"/volunteer-report/list?search=" + this.dataTable.search
						+ "&page=" + this.dataTable.pagination.page
						+ "&result=" + this.dataTable.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.dataTable.itemList = response.itemList;
							this.dataTable.itemCount = response.itemCount;
						});
			},

			startReport (item) {
				VolunteerReport.putStart(this, item.id, () => {
						this.showReportForm(item);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się rozpocząć raportu", errorResponse);
					});
			},

			showReportForm (item) {
				this.$router.push({
					path: "/app/project/" + item.projectId + "/volunteer-report/" + item.id,
				});
			}
		}
	};
</script>

<style scoped>

</style>
